import { createAsyncThunk } from '@reduxjs/toolkit';

import ApplyProcessApi, { ISubmitMailOfferRequest } from 'api/curo/ApplyProcessApi';
import { ApplyProcessActionTypes } from 'enums/curo/ApplyProcessActionTypes';

export const createSubmitMailOfferThunk = (api: ApplyProcessApi) =>
  createAsyncThunk(
    ApplyProcessActionTypes.SubmitMailOffer,
    async (body: ISubmitMailOfferRequest) => {
      const response = await api.submitMailOffer(body);

      return response;
    },
  );
